// the default is a WEBM copy stream
export const RECORDING_VERSION_DEFAULT = 'default';

// hls upload from desktop recorder
export const V3 = 'v3';

// User uploaded video files
export const V4 = 'v4';

// DASH upload from web recorders
export const V5 = 'v5';

// Videos with multiple clips
export const V6 = 'v6';

// HACK: Remove this after 3.6.16 has been released for the chrome-extension
export const UNKNOWN = 'unknown';
